var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDetailIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.80825e-07 11C2.15279e-07 17.075 4.925 22 11 22C17.075 22 22 17.075 22 11C22 4.925 17.075 7.46372e-07 11 4.80825e-07C4.925 2.15279e-07 7.46372e-07 4.925 4.80825e-07 11ZM8.793 14.293C8.61084 14.4816 8.51005 14.7342 8.51233 14.9964C8.5146 15.2586 8.61977 15.5094 8.80518 15.6948C8.99059 15.8802 9.2414 15.9854 9.5036 15.9877C9.7658 15.99 10.0184 15.8892 10.207 15.707L14.207 11.707C14.3945 11.5195 14.4998 11.2652 14.4998 11C14.4998 10.7348 14.3945 10.4805 14.207 10.293L10.207 6.293C10.0184 6.11084 9.7658 6.01005 9.5036 6.01233C9.2414 6.0146 8.99059 6.11977 8.80518 6.30518C8.61977 6.49059 8.51461 6.7414 8.51233 7.0036C8.51005 7.2658 8.61084 7.5184 8.793 7.707L12.086 11L8.793 14.293Z",
    fill: "#424242"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDetailIcon);
export default __webpack_public_path__ + "static/media/Detail-Icon.5fd17bc55b0cc59f9ae5d362000893eb.svg";
export { ForwardRef as ReactComponent };